import { Tag } from 'antd';
import styled from 'styled-components';

export const CTag = styled(Tag)<{
  height?: string;
  margin?: number;
  borderRadius?: string;
}>`
  position: relative;
  display: flex;
  height: 30px;
  align-items: center;
  margin-bottom: ${p => p.margin}px;
  cursor: pointer;
  max-width: 240px;
  width: fit-content;
  flex-shrink: 0;
  font-size: ${props => props.theme.font.size.xxs};
  font-weight: ${props => props.theme.font.weight.bold} !important;
  border-radius: 999px;

  gap: 6px;
  padding: 0px 8px 0px 12px;
  background: #f1f1f1;

  border: 0px;

  .text {
    font-weight: ${props => props.theme.font.weight.bold} !important;
    white-space: pre-wrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;

    transition: all 0.4s;
  }

  .ant-badge {
    font-size: ${props => props.theme.font.size.xxs};
    border: 0px;

    .ant-scroll-number {
      height: 16px;
      min-width: 16px;
      line-height: 16px;
      border-radius: 999px;

      padding: 0px 4px;
    }
  }
`;
